export default "__VITE_ASSET__DjXDLEOE__"